import Cookies from 'universal-cookie';

export default class RecentUserProductGroupsCookieStorage {
	cookies: Cookies;

	maxCount: number;

	cookieName: string;

	cookieOptions: { path: string; httpOnly: boolean };

	constructor(
		cookies: Cookies,
		maxCount: number,
		cookieName: string,
		cookieOptions: { path: string; httpOnly: boolean }
	) {
		this.cookies = cookies;
		this.maxCount = maxCount;
		this.cookieName = cookieName;
		this.cookieOptions = cookieOptions;
	}

	loadIdsBy(userId: string): string[] {
		const value = this.cookies.get(this.resolveCookieName(userId), {
			doNotParse: true,
		});
		return typeof value === 'string' && value !== '' ? value.split(',').slice(0, this.maxCount) : [];
	}

	saveIdsFor(userId: string, ids: string[]) {
		const expires = new Date();
		expires.setDate(expires.getDate() + 14);
		this.cookies.set(this.resolveCookieName(userId), ids.slice(0, this.maxCount).join(','), {
			...this.cookieOptions,
			expires,
		});
	}

	addGroupId(userId: string, id: string) {
		this.saveIdsFor(userId, [id, ...this.loadIdsBy(userId).filter((groupId) => groupId !== id)]);
	}

	removeGroupId(userId: string, id: string) {
		this.saveIdsFor(
			userId,
			this.loadIdsBy(userId).filter((groupId) => groupId !== id)
		);
	}

	resolveCookieName(userId: string) {
		return `${this.cookieName}-${userId}`;
	}
}
